import React from 'react';
import { Row, Col } from 'antd';
import { Frames } from './Frames';
import { Footer } from './Footer';
import { Header } from './Header';
import { Filters } from './Filters';
import { OwasEvaluationProvider } from './context';

export function Evaluation(): JSX.Element {
	return (
		<OwasEvaluationProvider>
			<Row gutter={[0, 24]}>
				<Col span={24}>
					<Header />
				</Col>
				<Col span={24}>
					<Filters />
				</Col>
				<Col span={24}>
					<Frames />
				</Col>
				<Col span={24}>
					<Footer />
				</Col>
			</Row>
		</OwasEvaluationProvider>
	);
}
